export default "__VITE_ASSET__BIT5f0kX__"